var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"@partial-block"),depth0,{"name":"@partial-block","data":data,"indent":"\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" class=\"ll-content-card ll-content-card--"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"navigation") : depth0), depth0))
    + "\">\n	<div class=\"ll-content-card__navigation\">\n		<button\n			class=\"\n				ll-content-card__button\n			\"\n			data-target=\"#happening\"\n		>\n            <img src=\"images/heart2.svg\" alt=\"Heart\">\n		</button>\n\n		<button\n			class=\"\n				ll-content-card__button\n			\"\n			data-target=\"#job\"\n		>\n            <img src=\"images/hand.svg\" alt=\"Heart\">\n		</button>\n\n        <button\n			class=\"\n				ll-content-card__button\n			\"\n			data-target=\"#contas\"\n		>\n            <img src=\"images/pizza.svg\" alt=\"Graphic\">\n		</button>\n\n		<button\n			class=\"\n				ll-content-card__button\n			\"\n			data-target=\"#help\"\n		>\n            <img src=\"images/market.svg\" alt=\"Heart\">\n		</button>\n	</div>\n	<div class=\"ll-content-card__block\">\n		<h2 class=\"ll-content-card__title\">\n			"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "\n		</h2>\n\n"
    + ((stack1 = container.invokePartial(require("./content-block.hbs"),depth0,{"name":"content/content-block","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "	</div>\n</div>\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/components/content/content-card.hbs
// module id = 8
// module chunks = 0